// extracted by mini-css-extract-plugin
export var legendIndicator = "_ey-1";
export var legendRight = "_ey-0";